module.exports = __webpack_public_path__ + "img/fit.b381ec51.webp";